import { queryOptions } from "@tanstack/react-query";
import type { Calendar } from "@terrabase/db";
import { axios, buildHeaders } from "./axios";

export const calendarsQueryOptions = queryOptions({
  queryKey: ["calendars"],
  queryFn: () => fetchCalendars(),
});

export const fetchCalendars = async () => {
  return axios
    .get<Calendar[]>("/calendars", {
      headers: buildHeaders(),
    })
    .then((r) => r.data);
};

export const calendarQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["calendar", id],
    queryFn: () => fetchCalendar(id),
  });

export const fetchCalendar = async (id: string) => {
  return axios
    .get<Calendar>(`/calendars/${id}`, {
      headers: buildHeaders(),
    })
    .then((r) => r.data);
};

export const createCalendar = async (data: { name: string }) => {
  return axios
    .post<Calendar>("/calendars", data, {
      headers: buildHeaders(),
    })
    .then((r) => r.data);
};

export const updateCalendar = async (data: { id: string; name: string }) => {
  return axios
    .put<Calendar>(
      `/calendars/${data.id}`,
      { name: data.name },
      {
        headers: buildHeaders(),
      },
    )
    .then((r) => r.data);
};

export const deleteCalendar = async (id: string) => {
  return axios
    .delete(`/calendars/${id}`, {
      headers: buildHeaders(),
    })
    .then((r) => r.data);
};
